var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"f","d":"M67.4,200v-91.2H98l4.6-35.6H67.4V50.5c0-10.3,2.9-17.3,17.6-17.3l18.8,0V1.4C100.6,1,89.4,0,76.4,0\r\n\tC49.3,0,30.7,16.6,30.7,47v26.2H0v35.6h30.7V200H67.4z"}));
}

Facebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"103.9px","height":"200px","viewBox":"0 0 103.9 200","style":{"enableBackground":"new 0 0 103.9 200"},"xmlSpace":"preserve"};

module.exports = Facebook;

Facebook.default = Facebook;
